(()=>{
  if(window.__jovelaTrustMounted)return;
  window.__jovelaTrustMounted=true;
  function sync(){
    const outputs=document.querySelectorAll('[data-jb-delivery-summary]');
    const hero=document.querySelector('#comprar [data-ha-delivery]');
    if(!outputs.length||!hero)return;
    const dates=[['Preparación','[data-ha-prep-date]'],['Despacho','[data-ha-dispatch-date]'],['Entrega','[data-ha-arrival-date]']]
      .map(([label,selector])=>[label,hero.querySelector(selector)?.textContent?.trim()])
      .filter(([,date])=>date&&date!=='—');
    if(dates.length)outputs.forEach(output=>{output.textContent=dates.map(([label,date])=>`${label}: ${date}`).join(' · ')});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
  document.addEventListener('shopify:section:load',sync);
})();
